import * as React from 'react'
import {CompanyProvider} from "./company-context";
import {SnackbarProvider} from "./snackbar-context";


function AppProviders({children}) {
    return (
        <SnackbarProvider>
            <CompanyProvider>{children}</CompanyProvider>
        </SnackbarProvider>

    )
}

export {AppProviders}
